module.exports = __webpack_public_path__ + "img/dsci0006.62a8080c.jpg";